import { render, staticRenderFns } from "./topCover_bottomTitle.vue?vue&type=template&id=baab8698&scoped=true&"
import script from "./topCover_bottomTitle.vue?vue&type=script&lang=js&"
export * from "./topCover_bottomTitle.vue?vue&type=script&lang=js&"
import style0 from "./topCover_bottomTitle.vue?vue&type=style&index=0&id=baab8698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baab8698",
  null
  
)

export default component.exports